/*--------------------------------------------------------------
# Custom scripts for Counting text block
--------------------------------------------------------------*/

// Define the animateStats function outside the motion preference check
function animateStats(block) {
    const counts = jQuery(block).find('.count');

    counts.each(function () {
        const $count = jQuery(this);
        const hasNoComma = $count.hasClass('no-comma');
        
        if (Number($count.data('figure')) === Number($count.text().replace(/,/g, ''))) {
            return; // Stop animation if figure value is already reached
        }

        // Animate from 0 to target value
        $count.prop('Counter', 0).animate({
            Counter: $count.data('figure')
        }, {
            duration: 3500,
            easing: 'swing',
            step: function (now) {
                // Format number based on presence of no-comma class
                const formattedNumber = hasNoComma ? 
                    Math.ceil(now).toString() : 
                    formatNumberWithCommas(Math.ceil(now));
                $count.text(formattedNumber);
            }
        });
    });
}

// Helper function to format numbers with commas
function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// Set each .count element directly if prefers-reduced-motion is enabled
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    jQuery('.count').each(function () {
        const $count = jQuery(this);
        const figure = $count.data('figure');
        const hasNoComma = $count.hasClass('no-comma');
        
        // Format number based on presence of no-comma class
        const formattedNumber = hasNoComma ? 
            figure.toString() : 
            formatNumberWithCommas(figure);
        
        $count.text(formattedNumber); // Directly set text without animation
    });
} else {
    // Use IntersectionObserver to trigger animations when elements are in view
    const observerOptions = {
        root: null, // viewport
        threshold: 0.1 // trigger when 10% of the element is visible
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const $statsBlock = jQuery(entry.target);
                $statsBlock.addClass('animate-stats');
                animateStats($statsBlock);
                observer.unobserve(entry.target); // Stop observing once animated
            }
        });
    }, observerOptions);

    // Observe each .countup-text element
    jQuery('.countup-text').each(function () {
        observer.observe(this);
    });
}